import {FormControlLabel, Link, styled} from '@mui/material';

const StyledFormControlLabel = styled(FormControlLabel)`
	align-items: flex-start;
	margin: 0;

	& .MuiCheckbox-root {
		padding: 0;
		margin-right: ${({theme}) => theme.spacing(1)};
	}
`;

const GeneralConditionsLink = styled(Link)`
	color: ${({theme}) => theme.palette.primary.main};
	font: inherit;
	vertical-align: baseline;

	&:hover {
		text-decoration: none;
	}
`;

export {StyledFormControlLabel, GeneralConditionsLink};
